export const ENABLE_AUTO_SCROLL_ON_CONSEQUENT_STEPS = true;
export const WIZARD_DESCRIPTION_COLOR = Styles.color.grey.seven;
export const MIN_PICKER_ASPECT_OPTIONS = 6;
